import type { Entity, Persisted } from '@tunasong/schemas'
import { personalizeCopy } from './personalize-copy.js'

/**
 * Who a persona change reaches (Joni §2 Footer): everyone in the nearest band space above the agent, or,
 * on a personal item, wherever the agent is used on that item. Walks the parent chain from the agent.
 */
export const scopeLineOf = (
  agent: Pick<Entity, 'parentId'>,
  ancestors: Record<string, Persisted<Entity>>,
  agentName: string
): string => {
  const parent = agent.parentId ? ancestors[agent.parentId] : undefined
  const seen = new Set<string>()
  let current = parent
  while (current && !seen.has(current.id)) {
    if (current.type === 'bandspace') {
      return personalizeCopy.scopeSpace(current.name?.trim() || 'this space')
    }
    seen.add(current.id)
    current = current.parentId ? ancestors[current.parentId] : undefined
  }
  return personalizeCopy.scopePersonal(agentName, parent?.type ?? 'item')
}
